import { ia, iaRa, io } from 'lib/helpers/utility';

export const createQueryFilters = (filters, view) => {
  const result = {};

  if (view) {
    result.status = [{ values: [view], formula: 'is' }];
  }

  if (!io(filters)) return result;

  Object.entries(filters).forEach(([key, value]) => {
    if (!ia(value)) return;
    const mappedFilters = iaRa(value);

    // Search filter: pass through searchTerm and fields directly
    if (key === 'search') {
      const searchItem = mappedFilters[0];
      const searchTerm = searchItem?.values?.searchTerm?.trim();
      if (searchTerm) {
        result[key] = { ...searchItem.values, searchTerm };
      }
      return;
    }

    const filteredItems = mappedFilters
      .map((item) => {
        if (!item.values && typeof item.values !== 'number') return null;

        if (ia(item.values)) {
          return {
            formula: item.formula || 'is',
            values: item.values.map((v) => v.value)
          };
        }

        return { formula: item.formula, values: item.values };
      })
      .filter(Boolean);

    if (filteredItems.length > 0) {
      result[key] = filteredItems;
    }
  });

  return result;
};
